<div class="toast-container position-fixed top-0 end-0 p-3">
    <div
        class="toast align-items-center text-white border-0"
        [ngClass]="{
        'bg-success': type === 'success',
        'bg-danger': type === 'error',
        'show': isVisible
        }"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
    >
        <div class="d-flex">
        <div class="toast-body fw-bold">
            {{ message }}
        </div>
        <button
            type="button"
            class="btn-close btn-close-white me-2 m-auto"
            (click)="hide()"
            aria-label="Close"
        ></button>
        </div>
        
    </div>
</div>